<script setup lang="ts">
import { isNotEmpty } from '@/utils/util'
import { computed, ref } from 'vue'

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
    required: true
  },
  baseInfo: {
    type: String,
    default: '',
    required: false
  },
  maxHeight: {
    type: Number,
    default: 100,
    required: true
  },
  enableExpand: {
    type: Boolean,
    default: true,
    required: false
  },
  enableTheme: {
    type: Boolean,
    default: false,
    required: false
  },
  overflowHidden: {
    type: Boolean,
    default: true,
    required: false
  }
})

const article = computed(() => {
  return props.modelValue?.replace(/<p><\/p>/g, '<br>')
})

const expand = ref(false)

const contentRef = ref<HTMLElement>()

const shouldExpand = computed(() => {
  if (!props.enableExpand) {
    return false
  }
  // console.log('contentRef.value?.scrollHeight:', contentRef.value?.scrollHeight)
  if (contentRef.value && contentRef.value?.scrollHeight) {
    return contentRef.value?.scrollHeight > props.maxHeight
  }
  return false
})

const baseInfo = computed(() => {
  return (
    props.baseInfo
      ?.replaceAll('<ul>', '')
      .replaceAll('</ul>', '')
      .replaceAll('<li>', '<span>')
      .replaceAll('</li>', '</span>。') + '<br/>' || ''
  )
})
</script>

<template>
  <div
    relative
    transition-transform
    cursor-text
    duration-300
    leading-8
    :style="{
      maxHeight: shouldExpand ? (expand ? 'fit-content' : `${props.maxHeight}px`) : 'fit-content',
      overflow: props.overflowHidden ? 'hidden' : ''
    }">
    <div
      v-if="isNotEmpty(props.baseInfo || '')"
      :style="{
        paddingBottom: '2px'
      }"
      class="content-rich content"
      :class="props.enableTheme ? 'text-theme-dark' : 'text-main'"
      v-html="baseInfo"></div>
    <div
      ref="contentRef"
      :style="{
        paddingBottom: shouldExpand ? '2.5rem' : '0px'
      }"
      class="content-rich content"
      :class="props.enableTheme ? 'text-theme-dark' : 'text-main'"
      v-html="article"></div>
    <div
      v-if="shouldExpand"
      :class="[expand ? '' : props.enableTheme ? 'bg-theme-light-to-trans' : 'bg-base-to-trans']"
      absolute
      z-1
      bottom-0
      right-0
      pt-6
      w-full
      flex="~ row"
      justify-end
      items-end>
      <div
        cursor-pointer
        @click="expand = !expand"
        font-bold
        :class="[props.enableTheme ? 'text-theme-main hover:text-theme-dark' : 'text-second hover:text-main']"
        md:mr-3
        pt-2
        mr-4
        mt-1>
        {{ expand ? $t('action.collapse') : $t('action.expand') }}
      </div>
    </div>
  </div>
</template>
